import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const PendingEvents = () => {
    const [events, setEvents] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/events/pending');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setEvents(data);
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };

    const handleDelete = async (eventId) => { 
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this event?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/events/delete/${eventId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setEvents(events.filter(event => event.id !== eventId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The event has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete event');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the event.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting event:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the event.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handleApprove = async (eventId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this event?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/events/approve/${eventId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setEvents(events.filter(event => event.id !== eventId));
                        Swal.fire({
                            title: "Approved!",
                            text: "The event has been approved.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to approve event');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to approve the event.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error approving event:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to approve the event.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter events based on search term
    const filteredEvents = events.filter(event =>
        (event.eventName && event.eventName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (event.organizerName && event.organizerName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (event.eventDescription && event.eventDescription.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (event.organizerEmail && event.organizerEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (event.organizerPhone && event.organizerPhone.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>PENDING EVENTS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                    <th>Event Name</th>
                                    <th>University Name</th>
                                    <th>Venue</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredEvents.map((eventItem) => (
                                    <tr key={eventItem.id}>
                                        <td>{eventItem.eventName}</td>
                                        <td>{eventItem.university}</td>
                                        <td>{eventItem.venue}</td>
                                        <td>{new Date(eventItem.date).toLocaleDateString('en-CA')}</td>
                                        <td>{eventItem.time}</td>
                                        <td><a href={eventItem.link} target="_blank" rel="noopener noreferrer" id='view-website'>Link</a></td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='app-details' onClick={() => handleApprove(eventItem.id)}>APPROVE</a>
                                            <a href="#!" id='del-details' onClick={() => handleDelete(eventItem.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingEvents;
